<template>
  <div class="flex justify-between items-center px-4 sm:px-0">
    <h1 class="text-xl font-bold truncate">
      {{ translate(`site.library.history.title`) }}
    </h1>
    <ContextMenuList
      :options="
        paths.map((path) => ({
          name: path.name,
          href: path.href,
        }))
      "
    >
      <template v-slot="{ isOpen, open, close }">
        <NamiButton
          button-type="secondary"
          @button-click="() => (isOpen ? close() : open())"
        >
          {{ translate(`site.library.history.tab.${current || "chapter"}`) }}
          <IconChevronDown />
        </NamiButton>
      </template>
    </ContextMenuList>
  </div>
  <NuxtPage />
</template>

<script setup lang="ts">
import { IconChevronDown } from "@tabler/icons-vue";

const nuxtApp = useNuxtApp();
const { locale, t: translate } = useI18n();
const mappedLocale = computed(() => reverseLocaleMap(locale.value));

const { current, paths } = useSubpaths(
  computed(() => ({
    default: "",
    rootPath: `/${mappedLocale.value}/library/history`,
    paths: [
      { name: translate("site.library.history.tab.chapter"), value: "" },
      { name: translate("site.library.history.tab.novel"), value: "novel" },
    ],
  })),
);
</script>
